// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gc-agency-name {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #1F2937;
}

p.gc-agency-handle {
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: rgba(75, 85, 99, 0.5);
}

.disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

.gc-agency-img {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 46px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gc-agency-img img {
  min-width: 100%;
}

.icon-badge-gold:before {
  content: "\\e900";
  color: #f2c94c;
}

.gc-pr-12 {
  padding-right: 12px !important;
}

.gc-pl-12 {
  padding-left: 12px !important;
}

.custom-invalid {
  border: 1px solid red !important;
}

.validation-text {
  display: block;
  margin-top: 5px;
  color: red;
}

.max-img-note {
  font-size: 12px;
  margin: 8px 0 20px 0;
}

.table-header > div:first-child {
  flex: 1 1 0;
  min-width: min-content;
}
.table-header > div:first-child .user-label {
  min-width: max-content;
}
.table-header h2 {
  line-height: 1;
}
.table-header .table-search-wrapper {
  max-width: 452px;
  flex: 1 1 auto;
  margin: 0;
}
.table-header .table-calendar-wrapper,
.table-header .field,
.table-header .export-btn,
.table-header p-button {
  margin: 0;
}
.table-header .field {
  margin-bottom: 0 !important;
}
@media (max-width: 1200px) {
  .table-header {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .table-header .table-search-wrapper {
    max-width: 100%;
    width: 100%;
  }
}

.bulkUpload-btn-company {
  flex: 0 0 162px;
}

.asso-container {
  max-height: 315px;
  overflow: auto;
}

.bulkUpload-btn-company {
  flex: 0 0 162px;
}

.asso-container {
  max-height: 315px;
  overflow: auto;
}

.text-center {
  text-align: center;
  width: 100%;
}

.associated-agencies:hover {
  background: #F6F8FF;
}

.associated-agencies-parent > :last-child {
  border-radius: 0 0 10px 10px;
}

::ng-deep .app-link-dropdown.p-dropdown {
  display: flex !important;
  align-items: center !important;
}
::ng-deep .app-link-dropdown.p-dropdown .p-dropdown-label {
  display: flex !important;
  align-items: center !important;
  padding: 0 12px !important;
  line-height: normal !important;
  height: 100% !important;
}

:host ::ng-deep .export-report .p-dropdown .p-dropdown-label {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

:host ::ng-deep .export-report .p-dropdown .p-dropdown-label {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

:host ::ng-deep .export-report .p-dropdown .p-dropdown-trigger {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/companies/companies.component.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;AACF;;AACA;EACI,oBAAA;EACA,eAAA;EACA,YAAA;AAEJ;;AAAA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAGJ;AAFI;EACE,eAAA;AAIN;;AAAA;EACE,gBAAA;EACA,cAAA;AAGF;;AADA;EACE,8BAAA;AAIF;;AAFA;EACE,6BAAA;AAKF;;AAHA;EACE,gCAAA;AAMF;;AAJA;EACE,cAAA;EACA,eAAA;EACA,UAAA;AAOF;;AALA;EACE,eAAA;EACA,oBAAA;AAQF;;AAHE;EACE,WAAA;EACA,sBAAA;AAMJ;AALI;EACE,sBAAA;AAON;AAHE;EACE,cAAA;AAKJ;AAFE;EACE,gBAAA;EACA,cAAA;EACA,SAAA;AAIJ;AADE;;;;EAIE,SAAA;AAGJ;AAAE;EACE,2BAAA;AAEJ;AACE;EA/BF;IAgCI,eAAA;IACA,2BAAA;EAEF;EADE;IACE,eAAA;IACA,WAAA;EAGJ;AACF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,iBAAA;EACA,cAAA;AAEF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;AACF;;AACA;EAEE,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAGA;EACE,wBAAA;EACA,8BAAA;AAAF;AAEE;EACE,wBAAA;EACA,8BAAA;EACA,0BAAA;EACA,8BAAA;EACA,uBAAA;AAAJ;;AAIA;EACE,wBAAA;EACA,6BAAA;EACA,qBAAA;AADF;;AAIA;EACE,wBAAA;EACA,6BAAA;EACA,qBAAA;AADF;;AAIA;EACE,wBAAA;EACA,6BAAA;EACA,qBAAA;AADF","sourcesContent":["\n.gc-agency-name{\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: #1F2937;\n}\np.gc-agency-handle{\n  font-style: italic;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgb(75 85 99 / 50%);\n}\n.disabled {\n    pointer-events: none;\n    cursor: default;\n    opacity: 0.6;\n  }\n.gc-agency-img{\n    width: 46px;\n    height: 46px;\n    border-radius: 50%;\n    overflow: hidden;\n    background: #fff;\n    color: #2d388b;\n    text-align: center;\n    font-size: 25px;\n    font-weight: 600;\n    flex: 0 0 46px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    img{\n      min-width:100%;\n    }\n}\n\n.icon-badge-gold:before {\n  content: \"\\e900\";\n  color: #f2c94c;\n}\n.gc-pr-12{\n  padding-right: 12px !important;\n}\n.gc-pl-12{\n  padding-left: 12px !important;\n}\n.custom-invalid {\n  border: 1px solid red !important;\n}\n.validation-text{\n  display: block;\n  margin-top: 5px;\n  color: red;\n}\n.max-img-note {\n  font-size: 12px;\n  margin: 8px 0 20px 0;\n}\n\n.table-header{\n  // Wrap at the title's narrowest width (as when h2 was min-content) but let it fill the row.\n  > div:first-child {\n    flex: 1 1 0;\n    min-width: min-content;\n    .user-label {\n      min-width: max-content;\n    }\n  }\n\n  h2 {\n    line-height: 1;\n  }\n\n  .table-search-wrapper {\n    max-width: 452px;\n    flex: 1 1 auto;\n    margin: 0;\n  }\n\n  .table-calendar-wrapper,\n  .field,\n  .export-btn,\n  p-button {\n    margin: 0;\n  }\n\n  .field {\n    margin-bottom: 0 !important;\n  }\n\n  @media(max-width:1200px) {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    .table-search-wrapper{\n      max-width: 100%;\n      width: 100%;\n    }\n  }\n}\n\n.bulkUpload-btn-company {\n  flex: 0 0 162px;\n}\n\n.asso-container {\n  max-height: 315px;\n  overflow: auto;\n}\n\n\n.bulkUpload-btn-company {\n  flex: 0 0 162px;\n}\n\n.asso-container {\n  max-height: 315px;\n  overflow: auto;\n}\n.text-center\n{\n  text-align: center;\n  width: 100%;\n}\n\n.associated-agencies:hover {\n  background: #F6F8FF;\n}\n\n.associated-agencies-parent > :last-child {\n  border-radius: 0 0 10px 10px\n}\n\n// App Link Dropdown Styles\n::ng-deep .app-link-dropdown.p-dropdown {\n  display: flex !important;\n  align-items: center !important;\n\n  .p-dropdown-label {\n    display: flex !important;\n    align-items: center !important;\n    padding: 0 12px !important;\n    line-height: normal !important;\n    height: 100% !important;\n  }\n}\n\n:host ::ng-deep .export-report .p-dropdown .p-dropdown-label {\n  display: none !important;\n  visibility: hidden !important;\n  opacity: 0 !important;\n}\n\n:host ::ng-deep .export-report .p-dropdown .p-dropdown-label {\n  display: none !important;\n  visibility: hidden !important;\n  opacity: 0 !important;\n}\n\n:host ::ng-deep .export-report .p-dropdown .p-dropdown-trigger {\n  display: none !important;\n  visibility: hidden !important;\n  opacity: 0 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
